if (!customElements.get('byla-pack-selector')) {
  customElements.define(
    'byla-pack-selector',
    class BylaPackSelector extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.formId);
        this.idInput = this.form?.querySelector('[name="id"]');
        this.inputs = Array.from(this.querySelectorAll('.byla-pack__input'));
        if (!this.form || !this.idInput || !this.inputs.length) return;

        this.inputs.forEach((input) => input.addEventListener('change', () => this.select(input)));

        // A pack is already the full amount: never let another widget add a quantity on top of it.
        this.form.closest('product-form')?.addEventListener('submit', () => this.lockQuantity(), true);

        const checked = this.inputs.find((input) => input.checked) || this.inputs[0];
        this.select(checked);
      }

      select(input) {
        if (!input || input.disabled) return;
        input.checked = true;
        this.inputs.forEach((item) => item.closest('.byla-pack__card')?.classList.toggle('is-selected', item === input));
        this.idInput.value = input.value;
        this.isPack = input.dataset.pack === 'true';
        this.updateStickyPrice(input);
      }

      lockQuantity() {
        if (!this.isPack) return;
        this.form.querySelectorAll('[name="quantity"]').forEach((field) => {
          field.value = '1';
        });
      }

      updateStickyPrice(input) {
        const sticky = document.getElementById(this.dataset.stickyPriceId);
        const price = input.closest('.byla-pack__card')?.querySelector('[data-pack-price]');
        if (!sticky || !price) return;
        if (this.stickyOriginal === undefined) this.stickyOriginal = sticky.innerHTML;
        if (input === this.inputs[0]) {
          sticky.innerHTML = this.stickyOriginal;
          return;
        }
        sticky.innerHTML = `<div class="byla-pack__sticky-price">${price.innerHTML}</div>`;
      }
    }
  );
}
